module.exports = __webpack_public_path__ + "static/img/empty.168aa44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty.png
// module id = OmQY
// module chunks = 1